export default function EmergencyFundSizePage() {
    return (
        <>

            <div className="container" style={{ "gap": "10px" }}>

                <h3 className="mb-4">How Big Should my Emergency Fund Be?</h3>

                <p>This is a great question to ask and a very tricky one to answer. How big your
                    emergency fund should be often depends on a number of personal factors: income, expenses, risk tolerance,
                    and even your peace of mind. Let&rsquo;s take a look at the rationales for the common
                    recommendations.</p>

                <hr className="my-4" />

                <h3 className="mb-4">Sizing Techniques</h3>

                <h4 className="mt-5 fs-5">One Thousand Dollars</h4>
                <p>The $1,000 emergency fund, popularized by Dave Ramsey, was designed specifically for
                    those who currently do not have an emergency fund. It was chosen, not to be the destination, but as an
                    important psychological milestone on a longer journey. For those who are living paycheck to paycheck with
                    little to nothing in savings, saving $1,000 serves to reinforce the behavior of saving money through a
                    relatively quick win, as well as to take some of the financial pressure off of individuals as they continue
                    to pursue other financial milestones. An emergency fund of this size is not sufficient for any working age
                    adult in a western nation but it is a critical first step in a longer journey</p>

                <p><span className="fw-bold">TLDR:</span> This should only be selected if you are building your first emergency
                    fund</p>

                <h4 className="mt-5 fs-5">Three to Six Months</h4>
                <p>This is the most common suggestion out there, sized to allow you to continue paying
                    your bills in the case of a loss of income. Generally it is referred to as three to six months of essential
                    spending, that&#39;s your mortgage/rent, groceries, insurance, etc. Without cutting back on non essentials
                    like subscriptions, eating out, and clothing, your emergency fund will last far less than three to six
                    months. </p>

                <p>What number should you choose though? Three months? Six months? &nbsp;Somewhere in
                    between? It all depends on your risk tolerance: </p>
                <ul>
                    <li>Two incomes in stable careers? Three months is more than sufficient.</li>
                    <li>One income, children, and health concerns? Aim for six months.</li>
                </ul>

                <p>Exactly what timeframe you choose depends on how likely a disruption is and how
                    impact a disruption would be to your life. If you are uncertain about how many months to choose, six months
                    is always a good bet! It pays to be safe rather than sorry.</p>

                <p><span className="fw-bold">TLDR:</span> This is the most popular strategy, save enough money to cover three to six
                    months of essential expenses, and increase the number of months as risk increases. </p>

                <h4 className="mt-5 fs-5">10% to 20% of Income</h4>
                <p>This works similar to the three to six month technique, the difference here is that
                    it is based on income rather than expenses. If you are someone who&rsquo;s expenses can vary wildly from
                    month to month, perhaps you are a business owner who periodically travels, it can be tough to determine how
                    much to save. Calculating based on your income, if it is more predictable than expenses, could be the better
                    route. </p>

                <p>When trying to determine how much to save, i.e 10% or 20%, apply the same reasoning
                    from the last section: </p>
                <ul>
                    <li>Lower risk: 10%</li>
                    <li>Higher Risk: 20%<br /></li>
                </ul>

                <p><span className="fw-bold">TLDR:</span> If your income is more predictable than your expenses, save enough money to replace 10-20%
                    of your yearly income.</p>

                <h4 className="mt-5 fs-5">Peace of Mind</h4>

                <p>This approach has you save up money until you feel confident that you are prepared
                    for any emergency. Peace of mind should be considered but it should also be grounded in reality. While it is
                    normal for people to have different tolerances to risk, it does not change the fact that the risk exists.
                    Some people are naturally stress free while others may be anxious. Both are normal, but either could lead
                    you astray.</p>
                <ul>
                    <li>Being too relaxed can leave you unprepared and exposed</li>
                    <li>Being too anxious can lead to over preparing and holding up
                        resources that could be better used elsewhere</li>
                </ul>

                <p><span className="fw-bold">TLDR:</span> Factor piece of mind into your decision but do not rely solely on it.
                </p>

                <hr className="my-4" />

                <h3 className="mb-4">Conclusion</h3>

                <p>Everyone&rsquo;s situation is different. Some are just starting on their financial journey while
                    others are polished professionals. Some bear significant family responsibilities while others are only
                    responsible for themselves. When sizing your emergency fund, start with an honest assessment of where you
                    are and what the future might hold. From there, choose a strategy that best provides you financial security
                    and peace of mind!</p>

            </div>
        </>
    )
}